var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeta(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.541,
    height: 16.021,
    viewBox: "0 0 20.541 16.021",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seta",
    transform: "translate(0.5 0.521)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(19.541 0) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path9425",
    d: "M7.823,297.182l-.01,14L3.72,307.095a1.243,1.243,0,1,0-1.757,1.757l6.228,6.235a1.246,1.246,0,0,0,1.765,0l6.228-6.235a1.246,1.246,0,1,0-1.767-1.757l-4.111,4.111.01-14.024a1.246,1.246,0,1,0-2.492,0Z",
    transform: "translate(-1.588 -295.913)",
    fill: "#54e046",
    stroke: "#54e046",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeta);
export default __webpack_public_path__ + "static/media/seta.42e82fd31f029f599fe9e6b209cc942c.svg";
export { ForwardRef as ReactComponent };